<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<nav id="main_nav">
  @if (isMobileOpen) {
    <div
      id="menu-backdrop"
      aria-hidden="true"
      tabindex="-1"
      class="menu-backdrop"
      [ngClass]="{ show: isMobileOpen }"
      (keyup)="isMobileOpen = false; emitBackdropClick(false)"
      (click)="isMobileOpen = false; emitBackdropClick(false)"
      @fadeIn
    ></div>
  }
  <div id="primary_nav-container" [ngClass]="{ show: isMobileOpen }">
    <div
      id="primary_nav"
      [ngClass]="{ show: isMobileOpen && isMobile, sticky: isSticky }"
      [@openClose]="isMobileOpen ? 'open' : 'closed'"
    >
      <div class="primary_nav-top">
        <div class="close-container">
          <button
            type="button"
            class="btn"
            (keyup)="isMobileOpen = false; emitBackdropClick(false)"
            (click)="isMobileOpen = false; emitBackdropClick(false)"
          >
            <span i18n="@@CLOSE">Close</span>
            <i class="fal fa-times"></i>
          </button>
        </div>
        <ul class="navbar">
          @for (item of items(); track item) {
            @if (!item.hidden && item.title && (!isAPohPage() || !item.hiddenPoh)) {
              <li class="navbar__item-container">
                <app-store-nav-item [item]="item" [index]="$index" [(opened)]="opened" />
              </li>
            }
          }
        </ul>
      </div>
      <div class="d-lg-none">
        <ul class="navbar navbar__footer">
          <li>
            <app-login-button [showAssociatedText]="true" />
          </li>
          <li>
            <app-country-select />
          </li>
          <li class="help_link">
            <a class="zendesk-contact" target="_blank" [href]="contactZendesk" i18n="@@CONTACT_US">Contact us</a>
          </li>
          <li class="help_link">
            <a
              [ngClass]="{ 'border-0': !isFrenchRegion }"
              [routerLink]="['/faq']"
              (click)="emitBackdropClick(false)"
              (keyup)="emitBackdropClick(false)"
              i18n="@@HELP_CENTER"
              >Help center</a
            >
          </li>
          @if (isFrenchRegion) {
            <li class="help_link">
              <a class="border-0" target="_blank" [href]="serviceClientIO2Url" i18n="@@SERVICE CLIENT IO2">Service Client iO2 </a>
            </li>
          }
        </ul>
        <span class="navbar-sf" i18n="@@soldByScalefast">Sold by ESW</span>
        <div class="fake-banner-bottom"></div>
      </div>
    </div>
  </div>
</nav>
